import { useContext, useEffect, useState } from "react";
import { ref, get } from "firebase/database";
import { db } from "../..";
import { Context } from "./AuthContext";

export function useUserRole() {
  const [role, setRole] = useState(null);
  const { user } = useContext(Context);

  useEffect(() => {
    if (user) {
      const userRef = ref(db, `users/${user.uid}/role`);
      get(userRef).then((snapshot) => {
        if (snapshot.exists()) {
          setRole(snapshot.val());
        } else {
          setRole(null);
        }
      });
    }
  }, [user]);

  return role;
}